import { createFileRoute } from "@tanstack/react-router";
import UeberUns from "@/pages/UeberUns";

const title = "Über uns: Wer hinter Kreditkarten.de steht | Kreditkarten.de";
const description =
  "Kreditkarten.de ist ein unabhängiger Kreditkartenvergleich für Deutschland. Wer wir sind, wie wir arbeiten, wie wir finanziert sind und wie Sie uns erreichen.";
const url = "https://www.kreditkarten.de/ueber-uns";

export const Route = createFileRoute("/ueber-uns")({
  head: () => ({
    meta: [
      { title },
      { name: "description", content: description },
      { property: "og:title", content: title },
      { property: "og:description", content: description },
      { property: "og:type", content: "website" },
      { property: "og:url", content: url },
      { name: "twitter:card", content: "summary_large_image" },
    ],
    links: [{ rel: "canonical", href: url }],
  }),
  component: UeberUns,
});
